import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import router from './router'
import axios from 'axios'
import store from './store'
import VueAxios from 'vue-axios'
import {
  ValidationProvider,
  ValidationObserver,
  localize,
  extend
} from 'vee-validate'

import { required, max, email, numeric, regex } from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'
import * as rules from 'vee-validate/dist/rules'
for (const rule in rules) {
  extend(rule, rules[rule])
}

extend('required', required)
extend('email', email)
extend('max', max)
extend('numeric', numeric)
extend('regex', regex)

localize('ja', ja)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  axios,
  VueAxios,
  render: h => h(App)
}).$mount('#app')
